/* globals Swiper */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import { sliderPagination } from '~/js/helpers';

const testimonialSliders = [...document.querySelectorAll('.testimonials-slider')];

function initTestimonialReadMore(section) {
	section.querySelectorAll('[data-testimonial-read-more]').forEach((readMoreButton) => {
		if (readMoreButton.dataset.readMoreBound === 'true') {
			return;
		}

		readMoreButton.dataset.readMoreBound = 'true';

		const figure = readMoreButton.closest('figure');

		if (!figure) {
			return;
		}

		const quote = figure.querySelector('[data-testimonial-quote]');
		const readLessButton = figure.querySelector('[data-testimonial-read-less]');

		if (!quote || !readLessButton) {
			return;
		}

		readMoreButton.addEventListener('click', () => {
			quote.classList.remove('is-collapsed');
			readMoreButton.classList.add('hidden');
			readLessButton.classList.remove('hidden');
			readMoreButton.setAttribute('aria-expanded', 'true');
			readLessButton.setAttribute('aria-expanded', 'true');
		});

		readLessButton.addEventListener('click', () => {
			quote.classList.add('is-collapsed');
			readLessButton.classList.add('hidden');
			readMoreButton.classList.remove('hidden');
			readMoreButton.setAttribute('aria-expanded', 'false');
			readLessButton.setAttribute('aria-expanded', 'false');
		});
	});
}

testimonialSliders.forEach((testimonialSlidersSection) => {
	initTestimonialReadMore(testimonialSlidersSection);
	const testimonialSlider = testimonialSlidersSection.querySelector('.swiper-testimonials-slider');
	const navigation = testimonialSlidersSection.querySelector('[data-swiper-navigation]');
	const nextButton = testimonialSlider ? testimonialSlider.querySelector('.swiper-button-next') : null;
	const prevButton = testimonialSlider ? testimonialSlider.querySelector('.swiper-button-prev') : null;
	const paginationElement = testimonialSlider ? testimonialSlider.querySelector('.swiper-pagination') : null;

	if (!testimonialSlider) {
		return;
	}

	const slidesPerView = Number(testimonialSlider.dataset.swiperColumns) || 3;
	const swiperConfig = {
		modules: [Navigation, Pagination, A11y],
		a11y: true,
		grabCursor: true,
		loop: false,
		watchOverflow: true,
		slidesPerView: 1,
		spaceBetween: 32,
		keyboard: {
			enabled: true,
		},
		breakpoints: {
			760: { slidesPerView: slidesPerView, spaceBetween: 32 },
			1024: { slidesPerView: slidesPerView },
		},
		on: {
			init(swiperInstance) {
				if (!navigation) {
					return;
				}

				navigation.hidden = swiperInstance.isLocked;
			},
			breakpoint(swiperInstance) {
				if (!navigation) {
					return;
				}

				navigation.hidden = swiperInstance.isLocked;
			},
			lock(swiperInstance) {
				if (!navigation) {
					return;
				}

				navigation.hidden = true;
			},
			unlock(swiperInstance) {
				if (!navigation) {
					return;
				}

				navigation.hidden = false;
			},
		},
	};

	if (nextButton && prevButton) {
		swiperConfig.navigation = {
			nextEl: testimonialSlider.querySelector('.swiper-button-next'),
			prevEl: testimonialSlider.querySelector('.swiper-button-prev'),
		};
	}

	if (paginationElement) {
		swiperConfig.pagination = sliderPagination(paginationElement);
	}

	new Swiper(testimonialSlider, swiperConfig);
});
